export const CONNECTION_SPACE = 16;
export const CONNECTION_BORDER_RADIUS = 8;
export const TOOLTIP_TOP_OFFSET = -10;
// TODO make it per column or column type
export const COLUMN_WIDTH = 340;
export const LOADER_ROW_ID = "loaderRow";
